/**
 * Shared status palette for Field Report tiles + rows.
 *
 * Historically the Draft/Pending/Approved colors were duplicated
 * inline across four card blocks and two list-row implementations,
 * causing repeated drift (iter117 audit). Now every view imports
 * this map so the badge palette is impossible to fork.
 *
 * Keys align with field-report vocabulary (`draft` /
 * `submitted_pending_review` / `completed`). CSE forms are normalized
 * to this vocabulary in FieldReports.js#loadForms so their badges
 * render through the same map.
 */
export const STATUS_META = {
  completed: { label: 'Approved', color: 'bg-green-100 text-green-700' },
  submitted_pending_review: { label: 'Pending', color: 'bg-blue-100 text-blue-700' },
  draft: { label: 'Draft', color: 'bg-yellow-100 text-yellow-700' },
};

/**
 * Kind-badge colors for the four field-report types. Callers can
 * either import this or pass their own `kindColor` string prop, so
 * one-off tabs (Approved) can still use it uniformly without a
 * lookup at every call site.
 */
export const KIND_COLOR = {
  precon: 'bg-blue-100 text-blue-700',
  softdig: 'bg-orange-100 text-orange-700',
  locate: 'bg-purple-100 text-purple-700',
  cse: 'bg-red-100 text-red-700',
};

export const KIND_LABEL = {
  precon: 'PreCon',
  softdig: 'Soft Dig',
  locate: 'Locate',
  cse: 'Confined Space',
};

export function resolveStatus(statusKey) {
  return STATUS_META[statusKey] || STATUS_META.draft;
}
